import '../assets/css/ZoomedImage.css'
import { getImageUrl } from '../services/CommonService'

function ZoomedImage({ cssClassNames, image, imgCssClassNames }) {

    return (
        <div className={`zoomedImgContainer ${cssClassNames}`}>
            <img src={getImageUrl(image.imageName)} className={`zoomedImg ${imgCssClassNames}`} alt={image.altText} />
        </div>
    )
}

export default ZoomedImage